import { z } from 'zod';
import { UserSchema } from '../../entities/user/user.schema';
/**
 * GET /api/v2/data-sync/excel-rows: the workbook of the Excel data
 * source, one list per sheet, live entities only. `id` is the Bliks id a
 * re-upload pairs by. A lead or owner is an email, null when there is none or
 * they are no live user.
 */ export const DataSyncExcelDepartmentRowSchema = z.object({
    id: z.string(),
    name: z.string(),
    /** The parent department's name; null for a top-level department. */ parent: z.string().nullable(),
    lead: z.string().nullable()
});
/** A team or a Funktion. */ export const DataSyncExcelOrgFunctionRowSchema = z.object({
    id: z.string(),
    name: z.string(),
    lead: z.string().nullable()
});
export const DataSyncExcelSystemRowSchema = z.object({
    id: z.string(),
    name: z.string(),
    /** The Systemverantwortlicher. */ owner: z.string().nullable()
});
/** A live internal person, with the names of their department and Stelle, and their Standort. */ export const DataSyncExcelPersonRowSchema = UserSchema.pick({
    firstName: true,
    lastName: true,
    email: true
}).extend({
    id: z.string(),
    department: z.string().nullable(),
    role: z.string().nullable(),
    location: z.string().nullable()
});
/**
 * Per sheet, the ids of the download's rows that Personio did not manage at
 * download time. Written on a hidden sheet and sent back with the upload:
 * only these entities can be an Abgang or a delete of that upload.
 */ export const DataSyncExcelDownloadedIdsSchema = z.strictObject({
    departments: z.array(z.string()),
    teams: z.array(z.string()),
    roles: z.array(z.string()),
    systems: z.array(z.string()),
    people: z.array(z.string())
});
export const ListDataSyncExcelRowsResponseSchema = z.object({
    departments: z.array(DataSyncExcelDepartmentRowSchema),
    teams: z.array(DataSyncExcelOrgFunctionRowSchema),
    roles: z.array(DataSyncExcelOrgFunctionRowSchema),
    systems: z.array(DataSyncExcelSystemRowSchema),
    people: z.array(DataSyncExcelPersonRowSchema),
    downloaded: DataSyncExcelDownloadedIdsSchema
});

//# sourceMappingURL=list-data-sync-excel-rows.schema.js.map